import React from 'react'
import {Routes, Route} from 'react-router-dom'
import Home from './pages/Home'
import NavBar from './components/NavBar'
import AboutPage from './pages/AboutPage'
import Footer from './components/Footer'
import ChatBot from './components/ChatBot'
import StudyTool from './pages/Study'
import StudyApp from './pages/av'
import FunctionalTestingQuiz from './pages/FunctionalTestingQuiz'

const App = () => {
  return (
    <div className='relative'>
    <NavBar/>
    <ChatBot/>
    
    
        <div className='px-4 sm:px-[5vw] md:px-[7vw] lg:px-[9vw]'></div>
        <Routes>
            <Route path='/' element ={<Home/>} />
            <Route path='/AboutPage' element ={<AboutPage/>} />
            <Route path='/Study' element ={<StudyTool/>} />
            <Route path='/av' element ={<StudyApp/>} />
            <Route path='/Val' element ={<FunctionalTestingQuiz/>} />
        </Routes>
    <Footer/>
    </div>
  )
}

export default App
